import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLoaderData } from 'react-router';
import { EoeContentBlockWrapper } from '../../../../../components/EoeDeviceStore/EoeContentBlockWrapper';
import { loadVirtualCatalogs } from '../../../../../selfservice/actions/index.js';
import type { CategoryProps } from '../../../../../common/types/category.js';
import type { PageResponse } from '../../../../../generated/api/pageResponse';

export const EoeStoreProduct = ({ category }: CategoryProps) => {
  const dispatch = useDispatch();
  const page = useLoaderData() as PageResponse;

  useEffect(() => {
    dispatch(loadVirtualCatalogs());
  }, [dispatch]);

  return <EoeContentBlockWrapper category={category} page={page} />;
};
